import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { VACCINES, DROPDOWNS } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(VACCINES.BASE);

// Export service with additional custom methods
export const VaccineService = {
  ...baseCRUD,

  // Custom methods
  getAgeGroups: () => fetchDropdowns(DROPDOWNS.BASE),
};

export default VaccineService;
